/* tslint:disable:max-line-length */
import { Injectable } from '@angular/core';
import { DetailedDropdownSuggestedService } from '../detailed-dropdown-suggested/detailed-dropdown-suggested.service';
import { DetailedDropdownBrowseService } from '../detailed-dropdown-browse/detailed-dropdown-browse.service';
import { map } from 'rxjs/operators';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FacebookService } from '../../../../../shared/services/facebook.service';

/* tslint:enable:max-line-length */

@Injectable()
export class DetailedApiService {

  _defaultLang = 'en_US';
  lang: string = this._defaultLang;

  suggestedTargetingList = [];

  adaccountId;

  constructor (private fbService: FacebookService,
               private detailedDropdownSuggestedService: DetailedDropdownSuggestedService,
               private detailedDropdownBrowseService: DetailedDropdownBrowseService,
               private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
    });
  }

  /**
   * Set adaccount id to be used for api calls
   * @param adaccountId
   */
  setAdaccount (adaccountId) {
    this.adaccountId = adaccountId;
  }

  search (q: string, adaccountId = this.adaccountId) {
    this.fbService.get({
      path: `/${adaccountId}/targetingsearch`,
      params: JSON.stringify({q: q, locale: this.lang})
    }).pipe(
      map((response: any) => response.data)
    ).subscribe((response: any) => {
      this.detailedDropdownSuggestedService.updateDropdown(response);
    });
  }

  browse (adaccountId = this.adaccountId) {
    this.fbService.get({
      path: `/${adaccountId}/targetingbrowse`,
      params: JSON.stringify({
              include_headers: false,
              include_nodes:   true,
              fields:          JSON.stringify([
                'id', 'name', 'type',
                'path', 'audience_size', 'key',
                'parent', 'info', 'info_title',
                'img', 'link']),
              locale:          this.lang
            })
    }).pipe(
      map((response: any) => response.data)
    ).subscribe((response: any) => this.detailedDropdownBrowseService.updateDropdown(response));
  }

  suggest (targetingList: Array<Object> = this.suggestedTargetingList, adaccountId = this.adaccountId) {
    this.suggestedTargetingList = targetingList;
    this.fbService.get({
      path: `/${adaccountId}/targetingsuggestions`,
      params: JSON.stringify({
              targeting_list: targetingList,
              locale:         this.lang
            })
    }).pipe(
      map((response: any) => response.data)
    ).subscribe((response: any) => {
      this.detailedDropdownSuggestedService.updateDropdown(response);
    });
  }

  validate (targetingList: Array<Object> = [], adaccountId = this.adaccountId) {
    return this.fbService.get({
      path: `/${adaccountId}/targetingvalidation`,
      params: JSON.stringify({
        targeting_list: targetingList,
        locale:         this.lang
      })
    }).pipe(
      map((response: any) => response.data)
    );
  }

  filteredSearch (q: string, limitType: string, adaccountId = this.adaccountId) {
    return this.fbService.get({
      path: `/${adaccountId}/targetingsearch`,
      params: JSON.stringify({
                      q:          q,
                      limit_type: limitType,
                      locale:     this.lang
                    })
    }).pipe(
      map((response: any) => response.data)
    );
  }
}
